"use client";

import React from "react";

export interface TalktribeStatsBlockProps {
    stats?: Array<{ metric: string; label: string }>;
}

export default function TalktribeStatsBlock({
    stats = [
        { metric: "15+", label: "AI Characters" },
        { metric: "40+", label: "Languages" },
        { metric: "∞", label: "Persistent Memory" },
        { metric: "Free", label: "To Use" }
    ]
}: TalktribeStatsBlockProps) {
    return (
        <section className="border-b border-zinc-900 bg-[#040405] py-12 w-full">
            <div className="container mx-auto px-6 md:px-12 lg:px-24">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-zinc-900">
                    {stats.map((stat, i) => (
                        <div key={i} className="flex flex-col items-center md:items-start md:px-8 first:pl-0 pt-4 md:pt-0">
                            <span className="text-3xl md:text-4xl font-light text-white font-mono tracking-tight">{stat.metric}</span>
                            <span className="text-[10px] font-mono text-zinc-500 uppercase tracking-widest mt-2">{stat.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
